import { Profissional } from 'graphql/types.generated'

export const formatNomeProfissional = (profissional?: Pick<Profissional, 'nome' | 'nomeSocial'>) =>
  profissional?.nomeSocial ? `${profissional.nomeSocial} (Nome social)` : profissional?.nome
